import { AsyncStoreItem } from '@lib';
import { GetOrderResponse } from 'src/sdk-servicing';

/**
 * GetOrderResult model
 */
export interface GetOrderResultModel {
  model: GetOrderResponse | null;
}

/**
 * GetOrderResponse model details
 */
export interface GetOrderResultStateDetails extends AsyncStoreItem {}

/**
 * GetOrderResult store state
 */
export interface GetOrderResultState extends GetOrderResultStateDetails, GetOrderResultModel {}

/**
 * Name of the GetOrderResult Store
 */
export const GET_ORDER_RESULT_STORE_NAME = 'getOrderResult';

/**
 * GetOrderResult Store Interface
 */
export interface GetOrderResultStore {
  /** GetOrderResult state */
  [GET_ORDER_RESULT_STORE_NAME]: GetOrderResultState;
}
